/*
 * Swym | Wishlist buttons on collection grids.
 *
 * Collections V2 auto-injection is disabled at the Swym account level
 * (retailerSettings.Wishlist.EnableCollections === false), so the buttons are
 * rendered by the theme as [data-swaction="addToWishlist"] markup instead.
 * Swym binds that markup only when initializeActionButtons() is called, and it
 * must be called again every time the grid is re-rendered.
 */
var swymGridObserver;
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function (swat) {
  // window.swat is undefined on this store; the callback arg is window._swat.
  var instance = swat || window._swat;

  function bindSwymButtons() {
    if (instance && typeof instance.initializeActionButtons === 'function') {
      instance.initializeActionButtons('body');
    }
  }

  // Server-rendered grid
  bindSwymButtons();

  // Globo Product Filter & Search re-renders the grid from its own template
  window.addEventListener('globoFilterRenderCompleted', bindSwymButtons);
  window.addEventListener('globoFilterRenderSearchCompleted', bindSwymButtons);

  // Native theme filters (settings.native_filters_poc). renderFilters() dispatches
  // theme:filters:init and renderProductGrid() replaces the grid immediately after,
  // synchronously - so defer past the current task to bind the new tiles, not the old.
  document.addEventListener('theme:filters:init', function () {
    setTimeout(bindSwymButtons, 0);
  });

  // Hook for any other custom render:
  // document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
  document.addEventListener('swym:collections-loaded', bindSwymButtons);

  // Infinite scroll comes from gest.trendsplant.com/storefront.js, which appends
  // tiles with appendChild and dispatches no event, so there is nothing to listen
  // for. Watch the DOM instead.
  //
  // Scoping this to #AjaxinateLoop proved unreliable: the observer registered on a
  // node that never received the appended tiles (observerFires stayed 0 across 53
  // appends). Observing a stable root removes that node-identity dependency.
  //
  // Cost is bounded by the guard: every mutation does one querySelector, and real
  // work happens only while an unbound button exists. Swym stamps .swym-loaded as
  // it binds, so the guard goes false once done and Swym's own class writes cannot
  // re-trigger this.
  if (window.MutationObserver) {
    var pending;
    swymGridObserver = new MutationObserver(function () {
      if (!document.querySelector('.swym-add-to-wishlist-view-product:not(.swym-loaded)')) return;
      // Schedule once and let it fire. Resetting the timer on every mutation
      // starved it: appends produce a continuous mutation stream, so the timer
      // never expired and binding ran 3 times against 28 opportunities.
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        bindSwymButtons();
      }, 150);
    });
    swymGridObserver.observe(document.body, { childList: true, subtree: true });
  }
});
